import { render, staticRenderFns } from "./PromoOdrPopin.vue?vue&type=template&id=5794f008&scoped=true&"
import script from "./PromoOdrPopin.vue?vue&type=script&lang=js&"
export * from "./PromoOdrPopin.vue?vue&type=script&lang=js&"
import style0 from "./PromoOdrPopin.vue?vue&type=style&index=0&id=5794f008&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5794f008",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37614586/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5794f008')) {
      api.createRecord('5794f008', component.options)
    } else {
      api.reload('5794f008', component.options)
    }
    module.hot.accept("./PromoOdrPopin.vue?vue&type=template&id=5794f008&scoped=true&", function () {
      api.rerender('5794f008', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/common/components/PromoOdrPopin.vue"
export default component.exports